const TIMEZONE_OPTIONS = [
   {
      id: '1',
      value: 'AST',
      label: 'UTC−4: Atlantic Standard Time (AST)',
   },
   {
      id: '2',
      value: 'ET',
      label: 'UTC−5: Eastern Standard Time (ET)',
   },
   {
      id: '3',
      value: 'CT',
      label: 'UTC−6: Central Standard Time (CT)',
   },
   {
      id: '4',
      value: 'MT',
      label: 'UTC−7: Mountain Standard Time (MT)',
   },
   {
      id: '5',
      value: 'PT',
      label: 'UTC−8: Pacific Standard Time (PT)',
   },
   {
      id: '6',
      value: 'AKT',
      label: 'UTC-9: Alaska Standard Time (AKT)',
   },
   {
      id: '7',
      value: 'HAT',
      label: 'UTC-10: Hawaii-Aleutian Standard Time (HAT)',
   },
   {
      id: '8',
      value: 'ST',
      label: 'UTC-11: Samoa Standard Time (ST)',
   },
   {
      id: '9',
      value: 'CHST',
      label: 'UTC+10: Chamorro Standard Time (CHST)',
   },
   {
      id: '10',
      value: 'WIT',
      label: 'UTC+12: Wake Island Time Zone (WIT)',
   },
];

export default TIMEZONE_OPTIONS;
